import { Loader } from "lucide-react";
import { getSplashMediaKind } from "../../../utils/splashMedia";

const SplashOverlay = ({ splashOverlay, screenSize, t, styles }) => {
  if (!splashOverlay.visible) return null;

  // mediaKind is computed upstream (useLoginForm) from the RAW stored gifUrl,
  // which always has a real file extension — the resolved display URL might
  // not (our local-dev streaming route has no extension in its path), so
  // falling back to re-deriving it from splashOverlay.url here would
  // misdetect video as image in that case.
  const mediaKind =
    splashOverlay.mediaKind || (splashOverlay.url ? getSplashMediaKind(splashOverlay.url) : null);

  return (
    <div style={styles.splashOverlay}>
      {splashOverlay.loading ? (
        <>
          <Loader
            size={screenSize.isMobile ? 40 : 48}
            className="animate-spin"
          />
          <p style={styles.splashMessage}>{t.loadingSplash}</p>
        </>
      ) : (
        <>
          {splashOverlay.url && (
            mediaKind === "video" ? (
              <video
                src={splashOverlay.url}
                style={styles.splashImage}
                autoPlay
                muted
                playsInline
                preload="auto"
              />
            ) : (
              <img
                src={splashOverlay.url}
                alt={t.splashAltText}
                style={styles.splashImage}
              />
            )
          )}
          <p style={styles.splashMessage}>{t.redirectingSoon}</p>
        </>
      )}
    </div>
  );
};

export default SplashOverlay;